<template>
  <li :class="`${type}-list-item`">
    <BlueCircle>
      <Centered>
        <span class="text-[15px] font-medium text-white font-bold">
          {{ num }}
        </span>
      </Centered>
    </BlueCircle>
    <div :class="`pl-4 list-item-text-${type}`">
      <slot />
    </div>
  </li>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import BlueCircle from "@/BookConsultation/components/BlueCircle.vue";
import Centered from "@/BookConsultation/components/Centered.vue";

export type ListItemSize = "small" | "medium";

export default Vue.extend({
  name: "ListItem",
  components: { BlueCircle, Centered },
  props: {
    num: {
      type: Number,
      required: true,
    },
    type: {
      type: String as PropType<ListItemSize>,
      required: false,
      default: "medium",
    },
  },
});
</script>

<style scoped>
.small-list-item {
  @apply flex items-center my-[12px];
}

.list-item-text-small {
  @apply text-[16px];
}

.medium-list-item {
  @apply flex items-center my-[24px];
}

.list-item-text-medium {
  @apply text-[14px];
}
</style>
